import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const MenuYearBilling = props => {
  const { optionFinance, currentYear, anchorElYear, handleClose, handleUpdateYear } = props;
  return (
    <Menu
      id='simple-menu'
      anchorEl={anchorElYear}
      keepMounted
      open={Boolean(anchorElYear)}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxHeight: 200,
          width: 100
        }
      }}
    >
      {Object.keys(optionFinance)
        .sort((a, b) => b - a)
        .map((e, i) => (
          <MenuItem selected={currentYear === e} key={e} onClick={() => handleUpdateYear(e)}>
            {e}
          </MenuItem>
        ))}
    </Menu>
  );
};

export default MenuYearBilling;
